import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewStore, AuthStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import PurchaseDialog from 'components/Store/PurchaseDialog';
import GiftEmailForm from 'components/GiftEmailForm';
import FullScreenDialog from 'components/FullScreenDialog';
import shallowCompare from 'react-addons-shallow-compare';
import { getCart, isGift } from 'selectors/store';

class GiftDialogContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => {
      const cart = getCart(state);
      return {
        cart,
        isGift: isGift(state),
        open: cart.length > 0 && isGift(state),
        activeDiscountCount: state.activeDiscountCount,
        paymentCompleted: state.payment.completed,
        method: state.payment.method,
        giftEmail: state.giftEmail
      };
    });
  }

  clearCart = () => {
    StoreOverviewActions.reset();
  };

  render() {
    const { cart, isGift, giftEmail } = this.state;
    if (cart.length < 1 || !isGift) {
      return null;
    }
    if (!giftEmail) {
      return (
        <FullScreenDialog
          open={this.state.open}
          toolbar={true}
          {...this.props}
          onRequestClose={this.clearCart}
        >
          <GiftEmailForm />
        </FullScreenDialog>
      );
    }
    return (
      <PurchaseDialog
        {...this.state}
        {...this.props}
        onRequestClose={this.clearCart}
      />
    );
  }
}

export default GiftDialogContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/GiftDialog.js